import './vendor';
import Swiper from 'swiper/dist/js/swiper.js';
import 'jquery-validation';
import '../../node_modules/jquery-validation/dist/additional-methods.js';
import '../../node_modules/jquery-validation/dist/localization/messages_ru.js';
import TweenMax from 'gsap/TweenMax';
import Lazy from 'jquery-lazy/jquery.lazy.js';

const $document = $(document);
const $window = $(window);
const $html = $('html');
const $body = $('body');

jQuery.extend(jQuery.validator.messages, {
	required: "Обязательно для заполнения",
	email: "Неправильный формат e-mail",
});

jQuery.validator.addMethod('fio', (value, element) => {
	if (!/[0-9]/i.test(value)) {
		return true;
	} else {
		return false;
	}
}, 'Неправильный формат');

jQuery.validator.addMethod('phone', (value, element) => {
	if (/^[0-9\+ ()-]*$/i.test(value)) {
		return true;
	} else {
		return false;
	}
}, 'Неправильный формат');

let app = {
	global: {
		init() {
			$('.js-goto').on('click', (e) => {
				let target = $(e.currentTarget).data('target') || $(e.currentTarget).attr('href');
				let $target = $(target);

				if ($target.length) {
					let time = $window.scrollTop() / 3;

					e.preventDefault();
					$html.removeClass('is-show-menu is-show-modal');
					$('[data-modal]').removeClass('is-show is-active');
					if (target !== '#main') {
						$html.addClass('is-hide-header');
					}
					$('html, body').animate({
						scrollTop: $target.offset().top - 120,
					}, time, 'easeOutExpo', () => {
						$html.removeClass('is-hide-header');
					});
				}
			});

			$document.on('click', '.js-toggle-class', (e) => {
				e.preventDefault();

				let options = $(e.currentTarget).data();

				switch (options.type) {
					case 'add':
						$html.addClass(options.class);
						break;
					case 'remove':
						$html.removeClass(options.class);
						break;
					case 'toggle':
						$html.toggleClass(options.class);
						break;
					default:
						$html.toggleClass(options.class);
						break;
				}
			});

			$('img.lazy').Lazy();
			app.modal.init();
		},
	},
	header: {
		init($header) {
			let $progress = $header.find('.header__progress span');
			let progress = 100 * $window.scrollTop() / ($document.outerHeight() - $window.outerHeight());

			$window.on('scroll.header', () => {
				progress = 100 * $window.scrollTop() / ($document.outerHeight() - $window.outerHeight());
				if ($window.scrollTop() > 10) {
					$html.addClass('is-header-fixed');
				} else {
					$html.removeClass('is-header-fixed');
				}
				$progress.css({
					width: `${progress}%`,
				});
			});
			$window.trigger('scroll.header');
		},
	},
	menu: {
		init($menu) {
			let mobile = $window.outerWidth() < 1024;

			$window.on('resize.menu', () => {
				mobile = $window.outerWidth() < 1024;

				$menu.find('.menu__list').css({
					marginLeft: $('.header .container').offset().left,
				});
				if(mobile) {
					$menu.find('.menu__content').css({
						width: '100%',
					});
				} else {
					$menu.find('.menu__content').css({
						width: $('.header .container').offset().left + 440,
					});
				}
			});
			$window.trigger('resize.menu');
		},
	},
	'gallery-slider': {
		init($slider) {
			let slider = new Swiper($slider.find('.swiper-container'), {
				loop: true,
				effect: 'fade',
				preloadImages: false,
				lazy: true,
				pagination: {
					el: $slider.find('.gallery__slider__pager')[0],
				},
			});
			let prevent = false;

			$slider.find('.swiper-slide-active .gallery__slider__item').removeClass('is-no-active');
			$slider.find('.gallery__slider__arrow--prev').on('click', (e) => {
				e.preventDefault();
				if (!prevent) {
					$slider.find('.gallery__slider__item').addClass('is-no-active');
					setTimeout(() => {
						slider.slidePrev();
					}, 500);
					prevent = true;
				}
			});

			$slider.find('.gallery__slider__arrow--next').on('click', (e) => {
				e.preventDefault();
				if (!prevent) {
					$slider.find('.gallery__slider__item').addClass('is-no-active');
					setTimeout(() => {
						slider.slideNext();
					}, 500);
					prevent = true;
				}
			});

			$slider.find('.gallery__slider__item__more a').on('click', (e) => {
				e.preventDefault();
				$slider.toggleClass('is-show-text');
				if ($slider.hasClass('is-show-text')) {
					$slider.find('.gallery__slider__item__text').stop().slideDown(250);
				} else {
					$slider.find('.gallery__slider__item__text').stop().slideUp(250);
				}
			});
			slider.on('slideChange', function () {
				setTimeout(() => {
					$slider.find('.gallery__slider__item').addClass('is-no-active');
					$slider.find('.swiper-slide-active .gallery__slider__item').removeClass('is-no-active');
					prevent = false;
				}, 250);
			});
		},
	},
	coundown: {
		init($coundown) {
			let date = $coundown.data('date').split(',');
			date = new Date(date[0], date[1] - 1, date[2], date[3], date[4]);
			let dates = [];
			let dates2 = [];
			let timeOut;
			let changeNumber = ($el, number, nextNumber) => {
				let tpl = '';

				if (number !== nextNumber) {
					tpl = `<span class="is-current">${number}</span><span class="is-next">${nextNumber}</span>`;
				} else {
					tpl = `<span>${number}</span>`;
				}

				$el.html(tpl);
			};
			let time = function () {
				let needDate = Math.floor((date - new Date()) / 1000);
				let needDate2 = needDate - 1;

				if (needDate > 0) {
					dates[0] = needDate % 60;
					dates2[0] = needDate2 % 60;

					needDate = Math.floor(needDate / 60);
					needDate2 = Math.floor(needDate2 / 60);
					if (dates[0] < 10) {
						dates[0] = '0' + dates[0];
					}
					if (dates2[0] < 10) {
						dates2[0] = '0' + dates2[0];
					}

					dates[1] = needDate % 60;
					dates2[1] = needDate2 % 60;

					needDate = Math.floor(needDate / 60);
					needDate2 = Math.floor(needDate2 / 60);
					if (dates[1] < 10) {
						dates[1] = '0' + dates[1];
					}
					if (dates2[1] < 10) {
						dates2[1] = '0' + dates2[1];
					}

					dates[2] = needDate % 24;
					dates2[2] = needDate2 % 24;

					needDate = Math.floor(needDate / 24);
					needDate2 = Math.floor(needDate2 / 24);
					if (dates[2] < 10) {
						dates[2] = '0' + dates[2];
					}
					if (dates2[2] < 10) {
						dates2[2] = '0' + dates2[2];
					}

					dates[3] = needDate;
					dates2[3] = needDate2;
					if (dates[3] < 10) {
						dates[3] = '0' + dates[3];
					}
					if (dates2[3] < 10) {
						dates2[3] = '0' + dates2[3];
					}

					timeOut = setTimeout(time, 1000);
				} else {
					dates[3] = '00';
					dates[2] = '00';
					dates[1] = '00';
					dates[0] = '00';
					dates2[3] = '00';
					dates2[2] = '00';
					dates2[1] = '00';
					dates2[0] = '00';
				}

				changeNumber($coundown.find('.js-coundown-day-1'), dates[3].toString()[0], dates2[3].toString()[0]);
				changeNumber($coundown.find('.js-coundown-day-2'), dates[3].toString()[1], dates2[3].toString()[1]);
				changeNumber($coundown.find('.js-coundown-hour-1'), dates[2].toString()[0], dates2[2].toString()[0]);
				changeNumber($coundown.find('.js-coundown-hour-2'), dates[2].toString()[1], dates2[2].toString()[1]);
				changeNumber($coundown.find('.js-coundown-min-1'), dates[1].toString()[0], dates2[1].toString()[0]);
				changeNumber($coundown.find('.js-coundown-min-2'), dates[1].toString()[1], dates2[1].toString()[1]);
				changeNumber($coundown.find('.js-coundown-sec-1'), dates[0].toString()[0], dates2[0].toString()[0]);
				changeNumber($coundown.find('.js-coundown-sec-2'), dates[0].toString()[1], dates2[0].toString()[1]);
				date--;
			};
			let $border = $coundown.find('.date__counter__border');
			let $path = $border.find('path');
			let $point = $coundown.find('.date__counter__point');
			let disable = true;
			let inOutQuad = (n) => {
				n *= 2;
				if (n < 1) {
					return 0.5 * n * n;
				}
				return - 0.5 * (--n * (n - 2) - 1);

			};
			let animation = () => {
				let animationSpeed = 2;
				let line = $path[0];
				let animationStart = performance.now();
				let lineLength = line.getTotalLength();
				let $svg = $path.closest('svg');
				let svgWidth = $svg[0].getBoundingClientRect().width;
				let svgHeight = $svg[0].getBoundingClientRect().height;
				let svgRealWidth = parseInt($svg.attr('width'), 10);
				let svgRealHeight = parseInt($svg.attr('height'), 10);
				let animatePoint = () => {
					requestAnimationFrame(function step(now) {
						let progress = (now - animationStart) / (animationSpeed * 1000);
						let top = line.getPointAtLength(lineLength * (1 - inOutQuad(progress))).y /
							(svgRealHeight / svgHeight * 100) * 100;
						let left = line.getPointAtLength(lineLength * (1 - inOutQuad(progress))).x /
							(svgRealWidth / svgWidth * 101) * 100;


						if (progress > 1) {
							progress = 1;
						}
						$point.css({
							top: top,
							left: left,
						});

						if (progress < 1) {
							requestAnimationFrame(step);
						}
					});
				};

				$path.css({
					strokeDashoffset: 0,
				});

				TweenMax.to($path, animationSpeed, {
					ease: inOutQuad,
					delay: 0,
					strokeDashoffset: line.getTotalLength(),
					onComplete() {
						animationStart = performance.now();
						TweenMax.to($path, animationSpeed, {
							ease: inOutQuad,
							delay: 0,
							strokeDashoffset: line.getTotalLength() * 2,
							onComplete() {
								if(!disable) {
									animation();
								}
							},
							onStart() {
								animatePoint();
							},
						});
					},
					onStart() {
						animatePoint();
					},
				});
			};

			time();

			$coundown.on('inview', (e, isInView) => {
				if (isInView) {
					disable = false;
					animation();
				} else {
					disable = true;
				}
			}).trigger('inview');
		},
		animate($path, $point, $coundown) {

		}
	},
	program: {
		init($program) {
			let $days = $program.find('.program__days');
			let $dayItem = $program.find('.program__days__item');
			let $dayArrow = $program.find('.program__days__arrow');
			let $schedule = $program.find('.program__schedule');
			let $prev = $program.find('.program__arrow--prev');
			let $next = $program.find('.program__arrow--next');
			let slider = new Swiper($program.find('.program__slider .swiper-container'), {
				loop: true,
				spaceBetween: 20,
				pagination: {
					el: $program.find('.program__slider__pager')[0],
				},
			});
			let checkArrows = () => {
				let $active = $program.find('.program__days__item.is-active');
				let $activeNext = $active.next('.program__days__item');
				let $activePrev = $active.prev('.program__days__item');

				if (!$activeNext.length || $activeNext.hasClass('is-disabled')) {
					$next.addClass('is-disabled');
				} else {
					$next.removeClass('is-disabled');
				}

				if (!$activePrev.length) {
					$prev.addClass('is-disabled');
				} else {
					$prev.removeClass('is-disabled');
				}
			};
			let disable = false;

			$dayItem.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				if(disable) {return false;}
				if (!$this.hasClass('is-active') && !$this.hasClass('is-disabled')) {
					let $target = $program.find(`.program__schedule[data-day="${$this.data('target')}"]`);
					let $scheduleActive = $program.find('.program__schedule.is-active');

					disable = true;
					$dayItem.removeClass('is-active');
					$scheduleActive.addClass('is-out');
					$this.addClass('is-active');
					$dayArrow.css({
						top: $this.offset().top - $days.offset().top + 7,
					});
					setTimeout(() => {
						$scheduleActive.removeClass('is-active is-out');
						$target.addClass('is-active');
						checkArrows();
						disable = false;
					}, 700);
				}
			});

			$next.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				if (!$this.hasClass('is-disabled')) {
					let $active = $program.find('.program__days__item.is-active');
					let $target = $active.next('.program__days__item');

					if ($target.length && !$target.hasClass('is-disabled')) {
						$target.trigger('click');
						checkArrows();
					}
				}
			});

			$prev.on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				if (!$this.hasClass('is-disabled')) {
					let $active = $program.find('.program__days__item.is-active');
					let $target = $active.prev('.program__days__item');

					if ($target.length) {
						$target.trigger('click');
						checkArrows();
					}
				}
			});

			$program.find('.program__slider__arrow--prev').on('click', (e) => {
				e.preventDefault();
				slider.slidePrev();
			});

			$program.find('.program__slider__arrow--next').on('click', (e) => {
				e.preventDefault();
				slider.slideNext();
			});

			slider.on('slideChange', () => {
				setTimeout(() => {
					$dayItem.removeClass('is-active');
					$program.find(`.program__days__item[data-target="${$program.find('.program__slider .swiper-slide-active').data('day')}"]`).addClass('is-active');
				}, 250);
			});
		}
	},
	input: {
		init($input) {
			let $field = $input.find('input, textarea');
			let check = () => {
				if ($field.val()) {
					$input.addClass('is-filled');
				} else {
					$input.removeClass('is-filled');
				}
			};

			check();
			$field.on('change', () => {
				check();
			});
			if ($field.attr('name') === 'fio') {
				$field.on('keyup change', () => {
					$field.val($field.val().replace(/\d/g, ''));
				});
			}
			if ($field.attr('name') === 'phone') {
				$field.on('keyup change', () => {
					$field.val($field.val().replace(/[a-zа-яA-ZА-Я]/g, ''));
				});
			}
		},
	},
	'modal-form-tabs': {
		init($tabs) {
			let $trigger = $tabs.find('.modal__form__tabs__list input');
			let $items = $tabs.find('.modal__form__tabs__item');

			$trigger.on('change', (e) => {
				let $this = $(e.currentTarget);

				if ($this.is(':checked')) {
					$items.removeClass('is-active');
					$tabs.find(`.modal__form__tabs__item[data-item="${$this.data('target')}"]`).addClass('is-active');
				}
			});
		},
	},
	order: {
		stepPercent: 20,
		init($order) {
			let $bookingTickets = $order.find('.js-booking-tickets');
			let $basketCultural = $order.find('.js-basket-cultural');
			let $basketTotal = $order.find('.js-basket-total');
			let $form = $order.find('.order__form');
			let $steps = $order.find('.order__steps');
			let $progress = $order.find('.order__progress span');
			let $prev = $order.find('.js-step-prev');
			let $submit = $order.find('.js-submit-form');
			let validator;
			let resultInfo = {
				fio: $order.find('.js-result-fio'),
				phone: $order.find('.js-result-phone'),
				email: $order.find('.js-result-email'),
				payment: $order.find('.js-result-payment'),
				cultural: $order.find('.js-result-cultural'),
				help: $order.find('.js-result-help'),
			};

			$order.find('.js-cultural-trigger').on('change', (e) => {
				let $this = $(e.currentTarget);

				if ($this.data('type') === 1) {
					$basketCultural.removeClass('is-hidden');
				} else {
					$basketCultural.addClass('is-hidden');
				}
				$basketTotal.text($this.data('price'));
			});

			validator = $form.validate({
				lang: 'ru',
				rules: {
					fio: {
						required: true,
						fio: true
					},
					phone: {
						required: true,
						phone: true
					},
					email: {
						required: true,
						email: true
					},
					'company-name': {
						required: true,
					},
					inn: {
						required: true,
					},
				},
				submitHandler: () => {
					let currentStep = $steps.data('step');
					let nextStep = currentStep + 1;

					if (currentStep === 5) {
						$.ajax({
							type: 'get',
							url: './ajax/order.json',
							data: $form.serialize(),
							dataType: 'json',
							success(result) {
								if (result.success) {
									app.success.init('Заявка на участие в тренинге', 'Отправлена', 'Спасибо за заявку. В ближайшее время с Вами свяжутся сотрудники Stylab, чтобы уточнить детали');
									setTimeout(() => {
										app.order.reset($order, validator);
										app.modal.close($('[data-modal="order"]'));
									}, 500);
								}
							},
						});
					} else if (nextStep === 5) {
						$.ajax({
							type: 'get',
							url: './ajax/order_info.json',
							data: $form.serialize(),
							dataType: 'json',
							success(result) {
								$.each(result, (i, e) => {
									resultInfo[i].text(e);
								});
								$steps.data('step', nextStep).attr('data-step', nextStep);
								$progress.css({
									width: `${nextStep * app.order.stepPercent}%`
								});
							}
						});
					} else {
						if (nextStep === 3) {
							$basketCultural.removeClass('is-hidden');
							$basketTotal.text($('.js-cultural-trigger:checked').data('price'));
						}
						$steps.data('step', nextStep).attr('data-step', nextStep);
						$progress.css({
							width: `${nextStep * app.order.stepPercent}%`
						});
					}
				},
			});

			$prev.on('click', (e) => {
				let currentStep = $steps.data('step');
				let nextStep = currentStep - 1;

				e.preventDefault();
				if (nextStep >= 1) {
					$steps.data('step', nextStep).attr('data-step', nextStep);
					$progress.css({
						width: `${nextStep * app.order.stepPercent}%`
					});
				}
			});

			$submit.on('click', (e) => {
				e.preventDefault();
				$form.trigger('submit');
			});

			$bookingTickets.find('input[type="checkbox"]').on('change', (e) => {
				let $this = $(e.currentTarget);

				if ($this.is(':checked')) {
					$bookingTickets.addClass('is-show');
				} else {
					$bookingTickets.removeClass('is-show');
				}
			});
		},
		reset($order, validator) {
			let $bookingTickets = $order.find('.js-booking-tickets');
			let $basketTotal = $order.find('.js-basket-total');
			let $form = $order.find('.order__form');
			let $basketCultural = $order.find('.js-basket-cultural');
			let $steps = $order.find('.order__steps');
			let $progress = $order.find('.order__progress span');

			$progress.css({
				width: `${app.order.stepPercent}%`,
			});
			$steps.data('step', 1).attr('data-step', 1);
			validator.resetForm();
			$form[0].reset();
			$basketCultural.addClass('is-hidden');
			$bookingTickets.removeClass('is-show');
			$basketTotal.text($('.js-cultural-trigger:not(:checked)').data('price'));
			$order.find('[data-app="input"]').each((i, e) => {
				$(e).find('input, textarea').trigger('change');
			});
		},
	},
	callback: {
		init($callback) {
			let $form = $callback.find('.callback__form');
			let validator;
			let emailEmpty = () => {
				return $callback.find('[name="email"]').val().trim().length === 0;
			};
			let phoneEmpty = () => {
				return $callback.find('[name="phone"]').val().trim().length === 0;
			};

			jQuery.validator.addMethod('phoneOrEmail', (value, element) => {
				if (!emailEmpty() || !phoneEmpty()) {
					return true;
				} else {
					return false;
				}
			}, 'Введите телефон или e-mail');

			validator = $form.validate({
				lang: 'ru',
				rules: {
					phone: {
						phoneOrEmail: true,
						phone: true,
					},
					email: {
						phoneOrEmail: true,
						email: true,
					},
				},
				submitHandler: () => {
					$.ajax({
						type: 'get',
						url: './ajax/callback.json',
						data: $form.serialize(),
						dataType: 'json',
						success(result) {
							if (result.success) {
								app.success.init('Ваш вопрос по тренингу', 'Отправлен', 'Спасибо за вопрос. В ближайшее время с вами свяжутся сотрудники Стайлаб, уже с готовым ответом');
								setTimeout(() => {
									app.callback.reset($callback, validator);
									app.modal.close($('[data-modal="callback"]'));
								}, 500);
							}
						},
					});
				},
			});
		},
		reset($order, validator) {
			let $form = $order.find('.callback__form');

			validator.resetForm();
			$form[0].reset();
			$order.find('[data-app="input"]').each((i, e) => {
				$(e).find('input, textarea').trigger('change');
			});
		},
	},
	modal: {
		init() {
			$('[data-modal-open]').on('click', (e) => {
				let $this = $(e.currentTarget);

				e.preventDefault();
				app.modal.open($this.data('modal-open'));
			});
			$('[data-modal-close]').on('click', (e) => {
				let $this = $(e.currentTarget);
				let $modal = $this.closest('[data-modal]');

				e.preventDefault();
				if ($modal.length) {
					app.modal.close($modal);
				} else {
					app.modal.close($('[data-modal]'));
				}
			});
		},
		open(target) {
			let $target = $(`[data-modal="${target}"]`);
			let $active = $('[data-modal].is-active');

			if ($active.length) {
				$active.removeClass('is-active');
				$target.data('prevent', $active.data('modal')).attr('data-prevent', $active.data('modal'));
			}
			$target.addClass('is-show is-active');
			$html.addClass('is-show-modal');
		},
		close($target) {
			let prevent = $target.data('prevent');
			$target.removeClass('is-show').data('prevent', '').attr('data-prevent', '');

			if (prevent) {
				$(`[data-modal="${prevent}"]`).addClass('is-active');
			}
			$html.removeClass('is-show-modal');
		},
	},
	success: {
		init(text1, text2, text3) {
			let $success = $('.success');
			let closeSuccessTimer;
			let time = $window.scrollTop() / 3;
			let closeSuccess = ($target) => {
				$html.removeClass('is-show-success');
				clearTimeout(closeSuccessTimer);
				setTimeout(() => {
					$('.success').remove();
				}, 500);
				$('html, body').animate({
					scrollTop: 0,
				}, time, 'easeOutExpo');
			};

			if ($success.length) {
				$success.remove();
			}

			$body.append(`<div class="success">
				<div class="success__container">
					<div class="success__content">
						<button class="success__close" type="button" data-success-close></button>
						<div class="success__label">${text1}</div>
						<div class="success__title">${text2}</div>
						<div class="success__text">${text3}</div>
						<div class="success__btn"><a class="button" href="#" data-success-close>На главную</a></div>
					</div>
				</div>
			</div>`);
			$success = $('.success');
			$('[data-success-close]').on('click', (e) => {
				e.preventDefault();
				closeSuccess($success);
			});
			setTimeout(() => {
				$html.addClass('is-show-success');

				closeSuccessTimer = setTimeout(() => {
					closeSuccess($success);
				}, 4000);
			}, 100);
		},
	},
	footer: {
		init($footer) {
			let mobile = $footer.find('.footer__top__title__arrow').is(':visible');

			$footer.find('.footer__top__title').on('click', (e) => {
				let $this = $(e.currentTarget);
				let $parent = $this.closest('.footer__top__col');
				let $menu = $parent.find('.footer__top__menu');

				if ($menu.length && mobile) {
					if ($parent.hasClass('is-active')) {
						$parent.removeClass('is-active');
						$menu.stop().slideUp(400);
					} else {
						$footer.find('.footer__top__col').removeClass('is-active');
						$footer.find('.footer__top__menu').stop().slideUp(400);
						$parent.addClass('is-active');
						$menu.stop().slideDown(400);
					}
				}
			});
		},
	},
};

app.global.init();

$('[data-app]').each((index, item) => {
	let $this = $(item);
	let appName = $this.data('app');

	if (app[appName]) {
		app[appName].init($this);
	}
});

let animation = {
	company: {
		init($company) {
			let top = $company.find('.company__list').offset().top;
			let showed = false;

			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 3);

					if (windowTop > top) {
						$company.addClass('is-show-items');
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
	price: {
		init($price) {
			let top = $price.find('.price__list').offset().top;
			let showed = false;

			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 3);

					if (windowTop > top) {
						$price.addClass('is-show-items');
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
	'icon-text': {
		init($item) {
			let top = $item.offset().top;
			let showed = false;

			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 3);

					if (windowTop > top) {
						$item.addClass('is-animated');
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
	'fade-up': {
		init($item) {
			let top = $item.offset().top;
			let showed = false;

			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 3);

					if (windowTop > top) {
						$item.addClass('is-animated');
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
	'icons-scroll': {
		init($icons) {
			if (!$icons.is(':visible')) {
				return false;
			}

			let scroll = 0;
			let direction = 'right';
			let auto = () => {
				if (direction === 'right') {
					scroll++;
				} else {
					scroll--;
				}
				$icons.scrollLeft(scroll);

				if (scroll <= 0) {
					direction = 'right';
				} else if (scroll - $icons.scrollLeft() > 2) {
					direction = 'left';
				}
			};
			let interval = setInterval(auto, 25);
			let timeout = false;

			$icons.on('touchstart', (e) => {
				clearInterval(interval);
				clearTimeout(timeout);
			});

			$icons.on('touchend', (e) => {
				timeout = setTimeout(() => {
					scroll = $icons.scrollLeft();
					interval = setInterval(auto, 25);
				}, 5000);
			});
		},
	},
	'shopping-map': {
		init($map) {
			let top = $map.offset().top;
			let showed = false;
			let i = 0;
			let animationSpeed = 0.6;
			let animate = () => {
				let $path = $map.find(`.js-path[data-i="${i}"]`);

				if (!$path.length) {
					return false;
				}
				if ($path.data('type') === 'line') {
					let $pathOut = $map.find(`.js-path[data-i="${i}"][data-line="out"]`);
					let $pathIn = $map.find(`.js-path[data-i="${i}"][data-line="in"]`);
					let pathLength = $pathOut[0].getTotalLength();

					$pathOut.css({
						strokeDasharray: pathLength,
					});
					$pathIn.css({
						strokeDashoffset: pathLength,
						strokeDasharray: pathLength,
					}).addClass('is-active');

					TweenMax.to($pathIn, animationSpeed, {
						ease: Linear.easeNone,
						opacity: 1,
						delay: 0,
						strokeDashoffset: 0,
						onComplete() {
							i++;
							animate();
						},
					});
				} else {
					$path.addClass('is-active');
					TweenMax.to($path, animationSpeed / 2, {
						ease: Linear.easeNone,
						opacity: 1,
						delay: 0,
						fill: '#ecc333',
						onComplete() {
							i++;
							animate();
						},
					});
				}
			};

			if (!$map.is(':visible')) {
				return false;
			}
			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 3);

					if (windowTop > top) {
						animate();
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
	'program': {
		init($item) {
			let top = $item.offset().top;
			let showed = false;

			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 3);

					if (windowTop > top) {
						$item.addClass('is-animated');
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
	'about-image': {
		init($item) {
			if(!$item.is(':visible')) {
				return false;
			}

			let top = $item.offset().top;
			let showed = false;
			let $icons = $item.find('.icon-item');
			let start = () => {
				setTimeout(() => {
					$item.removeClass('animate');
					$item.addClass('is-animated-rotate');
				}, 1400);
			};

			$icons.hover(
				(e) => {
					let $this = $(e.currentTarget);

					$item.addClass('is-animation-pause');
					$item.find(`.select-item[data-select="${$this.data('icon')}"]`).addClass('is-active');
					$this.addClass('is-active');
				},
				(e) => {
					$item.removeClass('is-animation-pause');
					$(e.currentTarget).removeClass('is-active');
					$item.find('.select-item').removeClass('is-active');
				}
			);

			$item.on('inview', (e, isInView) => {
				if (isInView) {
					$item.removeClass('is-animation-pause');
				} else {
					$item.addClass('is-animation-pause');
				}
			}).trigger('inview');

			$window.on('scroll', () => {
				if (!showed) {
					let windowTop = $window.scrollTop() + $window.outerHeight() * (2 / 4);

					if (windowTop > top) {
						$item.addClass('is-animated');
						start();
						showed = true;
					}
				}
			}).trigger('scroll');
		},
	},
};

$('[data-animation]').each((index, item) => {
	let $this = $(item);
	let animationName = $this.data('animation');

	if (animation[animationName]) {
		animation[animationName].init($this);
	}
});
